import TokenStorage from '@/services/token';

export default function auth({ next, router }) {
  if (!TokenStorage.isAuthenticated()) {
    return router.push({ name: 'login' });
  }

  return next();
}
